import { MyContentsModel } from "@app/models/system/my-contents.model";
import { contentsFeatureKey } from "@app/reducers/system/my-contents.reducer";
import { createFeatureSelector, createSelector } from "@ngrx/store";

export interface MyContentsState {
    contents: MyContentsModel[];
}

export const getContentsState = createFeatureSelector<MyContentsState>(contentsFeatureKey);

export const getContents = createSelector(
    getContentsState,
    (state: MyContentsState) => state.contents
);
